import PageContentful from '@/components/PageContentful';
import requestPage from '@/contentful/requestPage';
import { getAllPageItems } from '@/contentful/requestPageCollection';

export default PageContentful;

export async function getStaticProps({ preview, params }) {
  const slug = '/' + params.slug.join('/');
  const { sys } =
    (await getAllPageItems(preview)).find((item) => item.path === slug) || {};

  if (!sys?.id) {
    return { notFound: true };
  }

  const data = await requestPage({ id: sys.id, preview });
  const theme = slug.includes('/lotto-6aus49/')
    ? 'lotto6aus49'
    : slug.includes('/eurojackpot/')
      ? 'eurojackpot'
      : slug.includes('/gluecksspirale/')
        ? 'gluecksspirale'
        : slug.includes('/keno/')
          ? 'keno'
          : slug.includes('/rubbellose/')
            ? 'rubbellose'
            : slug.includes('/ueber/toto')
              ? 'toto'
              : '';
  return { props: { ...data['page'], theme } };
}

export const getStaticPaths = async ({ preview }) => {
  let foundNews = 0;
  return {
    paths: (await getAllPageItems(preview))
      .map((item) => {
        return {
          params: {
            slug: item.path.slice(1).split('/'),
          },
        };
      })
      .filter((item) => {
        if (process.env.NEXT_PUBLIC_PRODUCTION_INSTANCE === 'true') {
          return true;
        }
        const isNews = item.params.slug.includes('neuigkeiten');
        if (isNews) {
          foundNews++;
        }
        return !isNews || foundNews < 13;
      }),
    fallback: false,
  };
};
